import { Fragment, type ReactNode } from 'react';

/** A one-line summary with `code` in it (front matter is plain text): backticks become <code>. */
export function withCode(text: string): ReactNode[] {
  return text.split(/`([^`]+)`/).map((part, i) => (i % 2 === 1 ? <code key={i}>{part}</code> : <Fragment key={i}>{part}</Fragment>));
}
